export const DEFAULT_SCROLL_SPEED = 15;
export const DEFAULT_SCROLL_DISTANCE = 200;
export const DEFAULT_STEP = 10;
